import {
    Typography,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import "./PreviousRequestModal.css";
import React from "react";
interface TagsModalProps {
    simulation: any;
    isOpen: boolean;
    onClose: () => void;
}

const TagsModal = ({ simulation, isOpen, onClose }: TagsModalProps) => {
    const { t } = useTranslation();
    const handleCloseTagsModal = (
    _event: React.SyntheticEvent<Element, Event>,
    reason: string
    ) => {
    if (reason && (reason === "backdropClick" || reason === "escapeKeyDown"))
        return;
    onClose();
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
    <Dialog
        open={isOpen}
        onClose={handleCloseTagsModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
        scroll="paper"
        fullScreen={isMobile}
    >
        <DialogContent>
            <DialogContentText
            id="alert-dialog-description"
            style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            color: "black",
            }}
        >
        <Typography
            fontSize="20px"
            marginBottom={"14px"}
            fontWeight="bold"
        >{t('caution')}!</Typography>

        <Typography marginBottom="10px">
            {t('tagModalTextOne')} <b>{simulation?.target_syllabus?.name}</b> {t('tagModalTextTwo')} <b>{simulation?.syllabus?.name}</b> {t('tagModalTextThree')} <b>5</b> {t('tagModalTextFour')}
        </Typography>
        </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ paddingRight: "20px", paddingBottom: "20px" }}>
        {
        <Button
            onClick={() => {
            onClose();
            }}
            color="primary"
            variant="contained"
        >
            {t("continueText")}
        </Button>
        }
    </DialogActions>
    </Dialog>
);
};

export default TagsModal;
